import React, { useState } from "react";
import "./Login.css"; // Reusing login styles

function Register() {
  const [formData, setFormData] = useState({
    username: "",
    full_name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  // Get language from localStorage
  const lang = localStorage.getItem("lang") || "en";

  // Translation map
  const t = {
    en: {
      register: "Register",
      username: "Username",
      usernamePlaceholder: "Choose a username",
      fullName: "Full Name",
      fullNamePlaceholder: "Enter your full name",
      email: "E-mail",
      emailPlaceholder: "Enter your email",
      password: "Password",
      passwordPlaceholder: "Create a password",
      confirmPassword: "Confirm Password",
      confirmPasswordPlaceholder: "Re-enter your password",
      registerBtn: "Register",
      alreadyAccount: "Already have an account?",
      loginHere: "Login here",
      passwordMismatch: "Passwords do not match.",
      registrationSuccess: "Registration successful!",
      registrationFailed: "Registration failed",
      registrationError: "An error occurred during registration.",
    },
    bn: {
      register: "নিবন্ধন",
      username: "ইউজারনেম",
      usernamePlaceholder: "একটি ইউজারনেম দিন",
      fullName: "পূর্ণ নাম",
      fullNamePlaceholder: "আপনার পূর্ণ নাম লিখুন",
      email: "ই-মেইল",
      emailPlaceholder: "আপনার ই-মেইল লিখুন",
      password: "পাসওয়ার্ড",
      passwordPlaceholder: "একটি পাসওয়ার্ড তৈরি করুন",
      confirmPassword: "পাসওয়ার্ড নিশ্চিত করুন",
      confirmPasswordPlaceholder: "পাসওয়ার্ড পুনরায় লিখুন",
      registerBtn: "নিবন্ধন করুন",
      alreadyAccount: "ইতোমধ্যে একটি অ্যাকাউন্ট আছে?",
      loginHere: "এখানে লগইন করুন",
      passwordMismatch: "পাসওয়ার্ড মিলছে না।",
      registrationSuccess: "নিবন্ধন সফল হয়েছে!",
      registrationFailed: "নিবন্ধন ব্যর্থ হয়েছে",
      registrationError: "নিবন্ধনের সময় একটি ত্রুটি ঘটেছে।",
    },
  }[lang];

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.password !== formData.confirmPassword) {
      alert(t.passwordMismatch);
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            username: formData.username,
            full_name: formData.full_name,
            email: formData.email,
            password: formData.password,
          }),
        }
      );

      const result = await response.json();

      if (!result.error) {
        alert(t.registrationSuccess);
        // window.location.href = "/login";
      } else {
        alert(result.msg || t.registrationFailed);
      }
    } catch (error) {
      console.error("Registration error:", error);
      alert(t.registrationError);
    }
  };

  return (
    <div className={`login ${lang === "bn" ? "bn-font" : ""}`}>
      <h2 className="login-title">{t.register}</h2>
      <form className="login" onSubmit={handleSubmit}>
        <div className="input-box">
          <label className="input-title" htmlFor="username">
            {t.username}
          </label>
          <input
            id="username"
            name="username"
            className="input-field"
            type="text"
            placeholder={t.usernamePlaceholder}
            value={formData.username}
            onChange={handleChange}
            required
          />
        </div>
        <div className="input-box">
          <label className="input-title" htmlFor="full_name">
            {t.fullName}
          </label>
          <input
            id="full_name"
            name="full_name"
            className="input-field"
            type="text"
            placeholder={t.fullNamePlaceholder}
            value={formData.full_name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="input-box">
          <label className="input-title" htmlFor="email">
            {t.email}
          </label>
          <input
            id="email"
            name="email"
            className="input-field"
            type="email"
            placeholder={t.emailPlaceholder}
            autoComplete="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="input-box">
          <label className="input-title" htmlFor="password">
            {t.password}
          </label>
          <input
            id="password"
            name="password"
            className="input-field"
            type="password"
            placeholder={t.passwordPlaceholder}
            autoComplete="new-password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </div>
        <div className="input-box">
          <label className="input-title" htmlFor="confirmPassword">
            {t.confirmPassword}
          </label>
          <input
            id="confirmPassword"
            name="confirmPassword"
            className="input-field"
            type="password"
            placeholder={t.confirmPasswordPlaceholder}
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </div>

        <button className="navbar-login-button" type="submit">
          {t.registerBtn}
        </button>
        <div className="forgot-password">
          <div>
            {t.alreadyAccount} <a href="/login">{t.loginHere}</a>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Register;
